module.exports = __webpack_public_path__ + "img/banner8.33b601e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner8.png
// module id = /q88
// module chunks = 2